import Dialog from './ui-control/Dialog';
import TooltipWrapper from './ui-control/TooltipWrapper';
import XInput from './common/XInput';
import XButton from './common/XButton';
import { cn } from '../utils/classNames';
import { partyCardFrameClasses } from './common/listItemClasses';
import {
    finalSettlementHeaderClasses,
    finalSettlementTitleClasses,
    finalSettlementSubtitleClasses,
} from './FinalSettlementBaseHeader';

const dropdownClasses =
    'absolute top-full left-0 right-0 z-10 ' +
    'max-h-50 overflow-y-auto border rounded bg-surface';

const dropdownItemClasses =
    'px-4! py-2! cursor-pointer hover:bg-border-light';

const dropdownItemNameClasses = 'font-medium';
const dropdownItemEmailClasses = 'text-xs text-disabled';
const dropdownInfoClasses = 'px-4! py-2! text-disabled';

const formRowClasses = 'flex flex-wrap gap-6 items-end';
const formInputColClasses = 'w-full md:w-1/2';
const formButtonColClasses = 'flex items-end';

const buttonWrapperClasses = 'cursor-not-allowed';
const buttonWrapperEnabledClasses = 'cursor-default!';

const reassignButtonClasses =
    'h-10 pointer-events-none [filter:grayscale(60%)_opacity(0.7)]';
const reassignButtonEnabledClasses =
    'pointer-events-auto! [filter:none]!';

const confirmContentClasses = 'flex justify-center mt-8';
const confirmActionsClasses = 'flex justify-center mt-8';
const confirmYesClasses = 'w-24 h-14';
const confirmNoClasses = 'ml-4';

const LifeCarePlanReassignment = ({
    users,
    selectedUser,
    selectedUserName,
    assignmentLabel,
    isEnabled,
    isSearching,
    isReassigning,
    isConfirmModalOpen,
    inputValue,
    isDropdownOpen,
    dropdownRef,
    handleInputChange,
    openDropdown,
    handleSelectUser,
    requestReassign,
    confirmReassign,
    cancelReassign,
}) => (
        <>
            <div className="mt-6">
                <div className={`${finalSettlementHeaderClasses} rounded-t`}>
                    <div>
                        <h3 className={finalSettlementTitleClasses}>Reassignment</h3>
                        <p className={finalSettlementSubtitleClasses}>
                            Reassign this case to a different user
                        </p>
                        {assignmentLabel && (
                            <p className="mb-0! text-[calc(var(--spacing)*3.25)] text-white">
                                {assignmentLabel}
                            </p>
                        )}
                    </div>
                </div>

                <div className={partyCardFrameClasses}>
                    <div className={formRowClasses}>
                        <div className={formInputColClasses}>
                            <div ref={dropdownRef} className="relative">
                                <XInput
                                    label="Assign to"
                                    name="reassignUser"
                                    value={selectedUser ? selectedUserName : inputValue}
                                    onChange={handleInputChange}
                                    onFocus={openDropdown}
                                    placeholder="Search users by name or email..."
                                    disabled={isReassigning}
                                />
                                {isDropdownOpen && (
                                    <div className={dropdownClasses}>
                                        {isSearching ? (
                                            <div className={dropdownInfoClasses}>Loading...</div>
                                        ) : users?.length > 0 ? (
                                            users.map((user) => (
                                                <div
                                                    key={user?._id}
                                                    className={dropdownItemClasses}
                                                    onClick={() => handleSelectUser(user)}
                                                >
                                                    <div className={dropdownItemNameClasses}>
                                                        {[user?.firstName, user?.lastName].filter(Boolean).join(' ')}
                                                    </div>
                                                    <div className={dropdownItemEmailClasses}>
                                                        {user?.email}
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <div className={dropdownInfoClasses}>No users found</div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className={formButtonColClasses}>
                            <TooltipWrapper
                                showTooltip={!isEnabled}
                                title="Select a user to reassign"
                                variant="error"
                            >
                                <span className={cn(buttonWrapperClasses, isEnabled && buttonWrapperEnabledClasses)}>
                                    <XButton
                                        className={cn(reassignButtonClasses, isEnabled && reassignButtonEnabledClasses)}
                                        onClick={requestReassign}
                                        loading={isReassigning}
                                        loadingText="Reassigning..."
                                        buttonText="Reassign"
                                    />
                                </span>
                            </TooltipWrapper>
                        </div>
                    </div>
                </div>
            </div>

            <Dialog
                isModalOpen={isConfirmModalOpen}
                onToggleDialog={(isOpen) => { if (!isOpen) cancelReassign(); }}
                mode="small-half"
                isCloseIconHidden={false}
            >
                <div className={confirmContentClasses}>
                    <h3 className="title">
                        Are you sure you want to reassign this case to {selectedUserName}?
                    </h3>
                </div>
                <div className={confirmActionsClasses}>
                    <XButton
                        size="lg"
                        className={confirmYesClasses}
                        onClick={confirmReassign}
                        loading={isReassigning}
                        loadingText="..."
                        buttonText="Yes"
                    />
                    <XButton
                        size="lg"
                        className={confirmNoClasses}
                        onClick={cancelReassign}
                        buttonText="No"
                    />
                </div>
            </Dialog>
        </>
);

export default LifeCarePlanReassignment;
